'use strict';

var fragt = fragt || {};

fragt.accordion = fragt.accordion || new function () {
    this.init = function() {

        var accordionToggles = document.querySelectorAll('.js-accordion-toggle');
        var accordion = document.querySelectorAll('.accordion');

        for (var i = 0; i < accordionToggles.length; i++) {
            accordionToggles[i].addEventListener('click', function(e) {
                e.preventDefault();
                var element = e.currentTarget;

                accordionAnimate(element);
            });

            // Check for openByDefault
            accordionAnimate(accordionToggles[i], true);
        }



        for (var x = 0; x < accordion.length; x++) {
            var currentAccordion = accordion[x];
            var currentAccordionId = accordion[x].getAttribute('data-idpassed');
            var accordionItem = currentAccordion.querySelectorAll('.accordion__item-title');

            if (currentAccordionId && currentAccordionId.length > 0) {
                for (var j = 0; j < accordionItem.length; j++) {
                    var accordionItemId = accordionItem[j].getAttribute('id');
                    if (accordionItemId === currentAccordionId) {
                        accordionAnimate(accordionItem[j]);
                        scrollToElement(accordionItem[j]);
                    }
                }
            }
        }
    };

    function accordionAnimate(element, openDefaultCheck) {
        var contentItem = element.closest(".js-accordion-toggle").nextElementSibling;
        var isOpen = contentItem.classList.contains('accordion__item--active');

        if (!openDefaultCheck) {
            if (isOpen) {
                contentItem.classList.remove('accordion__item--active');
                element.classList.remove('accordion__item-title--active');
            } else {
                contentItem.classList.add('accordion__item--active');
                element.classList.add('accordion__item-title--active');
            }
        } else {
            if (!isOpen) {
                return;
            }
        }

        var elementContent = contentItem.querySelector('.js-accordion-content');

        if (elementContent !== undefined) {
            var elementContentHeight = elementContent.offsetHeight;
            var newHeight;
            var heightAttr = contentItem.dataset.height;

            if (heightAttr === undefined) {
                newHeight = contentItem.offsetHeight + elementContentHeight;
                contentItem.dataset.height = contentItem.offsetHeight;
            }
            else {
                if (heightAttr < contentItem.offsetHeight) {
                    newHeight = heightAttr;
                }
                else {
                    newHeight = contentItem.offsetHeight + elementContentHeight;
                }
            }
            contentItem.style.height = newHeight + 'px';
        }
    }

    function scrollToElement(element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}();
